import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

import { sortFood } from '../../util/util';

import 'react-bootstrap-typeahead/css/Typeahead.css';

/**
 * Concerns of this component:
 *   provide an autocomplete form to select a component
**/
class FoodSelect extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(newSelectedFoods) {
    this.props.setFoods(newSelectedFoods);
  }

  render() {
    const { options, selected, label, placeholder, multiple, emptyLabel } = this.props;

    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <Typeahead
          options={options.sort(sortFood)}
          labelKey={food => `${food.shortname}: ${food.recordid}`}
          selected={selected}
          multiple={multiple}
          onChange={this.handleChange}
          placeholder={placeholder || 'e.g. apple or A1014'}
          emptyLabel={emptyLabel || 'No matches found.'}
          submitFormOnEnter
          clearButton
        />
      </FormGroup>
    );
  }
}

FoodSelect.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired, // array of food objects
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  multiple: PropTypes.bool,
  emptyLabel: PropTypes.string,
  setFoods: PropTypes.func.isRequired,
};

export default FoodSelect;



// WEBPACK FOOTER //
// ./src/components/search/common/FoodSelect.js